import { Component } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-modal-service-form',
  templateUrl: './modal-service-form.component.html',
  styleUrls: ['./modal-service-form.component.scss'],
})
export class ModalServiceFormComponent {
  button_ok_title: string;
  question_title: string;
  related_service_category_id: number;

  // frm = new FormGroup({
  //   services: new FormArray<FormGroup<{
  //     identifier: FormControl,
  //     name: FormControl,
  //     description: FormControl,
  //     related_service_category_id: FormControl,
  //   }>>([])
  // })

  frm = new FormGroup({
    identifier: new FormControl('', [Validators.required]),
    name: new FormControl('', [Validators.required]),
    description: new FormControl(''),
    related_service_category_id: new FormControl(this.config.data!.related_service_category_id),
  });

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public dialogService: DialogService
  ) {
    this.button_ok_title = config.data!.button_ok_title;
    this.question_title = config.data!.question_title;
    this.related_service_category_id = config.data!.related_service_category_id;

    if (config.data!.initial_value) {
      this.frm.patchValue(config.data!.initial_value);
    }
  }

  // add(){
  //   const frmGroup = new FormGroup({
  //     identifier: new FormControl('', [Validators.required]),
  //     name: new FormControl('', [Validators.required]),
  //     description: new FormControl(''),
  //     related_service_category_id: new FormControl(this.related_service_category_id),
  //   });
  //   (this.frm.get('services') as FormArray).push(frmGroup);
  // }

  close() {
    this.ref.close();
  }

  save() {
    //this.ref.close({frm: this.frm.controls['services'].value});
    this.ref.close({ frm: this.frm.value });
  }
}
